// Ported as-is from WEEKLY_2.HTM.
import { COLORS, RADIUS } from "../lib/constants";

export function DietBadges({ recipe, colors }) {
  const tags = recipe.dietTags || [];
  const badges = [];
  if (tags.includes("vegan")) badges.push(["Vegan", COLORS.accentTint, colors.accent]);
  else if (tags.includes("vegetarian")) badges.push(["Vegetarian", COLORS.accentTint, colors.accent]);
  if (tags.includes("glutenFree")) badges.push(["GF", COLORS.amberTintDeep, COLORS.amberInkDeep]);
  if (badges.length === 0) return null;
  return (
    <>
      {badges.map(([label, bg, fg]) => (
        <span key={label} style={{ background: bg, color: fg, padding: "var(--space-hair) var(--space-md)", borderRadius: RADIUS.pill }}>
          {label}
        </span>
      ))}
    </>
  );
}

export function SeasonBadges({ recipe }) {
  const seasons = recipe.seasons || [];
  if (seasons.length === 0) return null;
  return (
    <>
      {seasons.map((s) => (
        <span key={s} style={{ background: COLORS.skyTint, color: COLORS.skyInk, padding: "var(--space-hair) var(--space-md)", borderRadius: RADIUS.pill }}>
          {s}
        </span>
      ))}
    </>
  );
}

export function CookingMethodBadges({ recipe }) {
  const methods = recipe.cookingMethod || [];
  if (methods.length === 0) return null;
  return (
    <>
      {methods.map((m) => (
        <span key={m} style={{ background: COLORS.plumTint, color: COLORS.plumInk, padding: "var(--space-hair) var(--space-md)", borderRadius: RADIUS.pill }}>
          {m}
        </span>
      ))}
    </>
  );
}
